import { atom } from 'jotai'

export const imageUploadErrorAtom = atom<string | null>(null)

imageUploadErrorAtom.onMount = (setAtom) => {
    return setAtom(null)
}